var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAd)?_c('div',[_c('div',{class:[_vm.type, _vm.description],attrs:{"id":_vm.index ? _vm.type + _vm.index : _vm.type}}),(_vm.typeAux)?_c('div',{attrs:{"id":_vm.typeAux}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }